import { Resource } from "src/app/core/jsonapi/resource";
import { prop, required } from "@rxweb/reactive-form-validators";

export class Integration extends Resource {
    public override type = 'integration';

    @prop()
    @required()
    public code!: string;

    @prop()
    @required()
    public name!: string;

    @prop()
    public configuration!: string;    

}